import { onAuthStateChanged } from "firebase/auth";
import React, { useEffect, useRef, useState } from "react";
import { auth, db } from "../firebase-config";
import { useLocation, useNavigate } from "react-router-dom";
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, orderBy, query, setDoc, updateDoc, where } from "firebase/firestore";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from '../redux/userReducer'
import { findCurrentWeekActivity, getClassType, getFirebaseDocs, getUrlParams, randomString } from '../common'
import { addDays, addHours, addMinutes, addMonths, eachDayOfInterval, endOfDay, endOfMonth, format, getWeek, isAfter, lastDayOfMonth, startOfDay, startOfMonth, startOfWeek, subDays, subHours } from "date-fns";

// import BasketBall from '../assets/Activities/BasketBall.png'
// import BigBand from '../assets/Activities/Big Band.png'
// import Cricket from '../assets/Activities/Cricket.png'
// import Drumsticks from '../assets/Activities/Drumsticks.png'
// import Football from '../assets/Activities/Football.png'
// import HockeyStick from '../assets/Activities/Hockey Stick.png'
// import Maracas from '../assets/Activities/Maracas.png'
// import Triangles from '../assets/Activities/Triangles.png'
// import Rugby from '../assets/Activities/Rugby.png'
// import Soccer from '../assets/Activities/Soccer.png'
// import Tambourine from '../assets/Activities/Tambourine.png'
// import Tennis from '../assets/Activities/Tennis.png'
// import Ukulele from '../assets/Activities/Ukulele.png'
// import Xylophone from '../assets/Activities/Xylophone.png'

const sensoryActivityImageMap = {
    'Exploring Sound and Movement': 'ExploringSoundandMovement',
    'Movement and motion': 'SensoryFusion',
    'Lights and shadows': 'Lightsandshadows',
    'Soft Touch and Texture': 'SoftTouchandTexture',
    'Nature Explores': 'NatureExplores',
    'Colours': 'Colours',
    'Earth Explores': 'EarthExplorers',
    'Emotions': 'Emotions',
    'Soft Sounds and Lullabies': 'SoftSoundsandLullabies',
    'Cause and Effect': 'CauseAndEffect',
    'Sensory Safari': 'SensorySafari',
    'Pop, Push, Squish, Pull & Splash': 'Pop,Push,Squish,Pull&Splash',
    'Wiggle & Wonder': 'Wiggle&Wonder',
    'Tactile Explores': 'TactileExplores',
    'Tiny Builders': 'TinyBuilders',
    'Touch, Tap & Pop': 'Touch,Tap&Pop',
}

const gymnasticsActivityImageMap = {
    'Shapes/Fundamentals': 'ShapesAndFundamentals',
    'Balance/Coordination': 'BalanceAndCoordination',
    'Jumping and Roll Introduction': 'JumpingAndRollIntroduction',
    'Rolls': 'Rolls',
    'Rhythm Gymnastics/Ball Skills + Handstand Introduction': 'RhythmGymnasticsBallSkillsAndHandstandIntroduction',
    'Handstands + Cartwheel Introduction': 'HandstandsAndCartwheelIntroduction',
    'Cartwheels + Advanced Balance': 'CartwheelsAndAdvancedBalance',
    'Bridges and High Kicks': 'BridgesandHighKicks',
    'Turns and Leaps': 'TurnsAndLeaps',
    'Advanced Jumping and Coordination': 'AdvancedJumpingAndCoordination',
    'Rhythm Gymnastics and Cartwheel': 'RhythmGymnasticsAndCartwheel',
    'Rolls and Extension passes': 'RollsAndExtensionPasses',
    'Cartwheel Extensions and Jumps': 'CartwheelExtensionsAndJumps',
    'Advanced Fundamentals and Rhythm Gymnastics': 'AdvancedFundamentalsAndRhythmGymnastics',
    'Advanced Balance and Rolls': 'AdvancedBalanceAndRolls',
    'Creative Routine Building & Educator Show': 'CreativeRoutineBuildingAndEducatorShow',
}

const activityWithImages = ['Basketball', 'Big Band', 'Cricket', 'Drumsticks', 'Football', 'Gymnastics', 'Hockey', 'Maracas', 'NFL', 'Rhythm Sticks', 'Rugby', 'Shakers', 'Soccer', 'Tambourine', 'Tennis', 'Triangles', 'Ukuleles', 'Xylophone', 'Yoga', 'SensoryFusion', ...Object.values(sensoryActivityImageMap), ...Object.values(gymnasticsActivityImageMap)]

const CalendarPdf = () => {

    const [events, setEvents] = useState([])
    const [educationCenter, setEducationCenter] = useState()


    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    const hoursToAdd = 11

    const startDate = startOfMonth(addMonths(new Date(), 1))
    const endDate = endOfMonth(addMonths(new Date(), 1))
    const monthDates = eachDayOfInterval({ start: startDate, end: endDate })

    const initialDayStart = days.findIndex(r => r === format(monthDates[0], 'EEE'))

    const [headerImage, setHeaderImage] = useState('')


    useEffect(() => {
        const urlParams = getUrlParams()
        fetchEvents(urlParams.id)
        fetchEducationCenter(urlParams.id)
    }, [])


    useEffect(() => {
        // setHeaderImage(require(`../assets/Calendars/${'Sports'} - ${format(startDate, 'MMM')} ${format(startDate, 'yyyy')}.jpg`))
        console.log('events', events)
        if (events.length > 0) {
            const classType = getClassType(events[0].activity, events[0].weekActivity)
            if (classType) {
                setHeaderImage(require(`../assets/Calendars/${classType || 'Sports'} - ${format(startDate, 'MMM').toUpperCase()} ${format(startDate, 'yyyy')}.jpg`))
            }
        }
        // setHeaderImage(require(`../assets/Calendars/Gymnastics - ${format(startDate, 'MMM')} ${format(startDate, 'yyyy')}.jpg`))
    }, [events])


    const fetchEducationCenter = async (id) => {
        const docData = await getDoc(doc(db, `education-centers`, id))
        setEducationCenter(docData)
    }


    const offsetTime = async (r, property) => {
        // if (r.groupId) {
        //     // Check if original event created in same timezone of current event.
        //     // console.log(r.groupId)
        //     const parentDoc = await (await getDoc(doc(collection(db, `events`), r.groupId))).data()
        //     if (parentDoc) {
        //         const parentOffset = new Date(parentDoc[property]).getTimezoneOffset()
        //         const childOffset = new Date(r[property]).getTimezoneOffset()
        //         if (parentOffset !== childOffset) {
        //             return addMinutes(new Date(r[property]), childOffset - parentOffset)
        //         }
        //     }
        //     // return new Date(r[property])
        // }
        // return new Date(r[property])

        return addHours(new Date(r[property]), 11)
    }

    const fetchEvents = async (id) => {
        // Offset the query window so events that fall on the first/last of the month
        // (stored in UTC) are still included when viewed in AEST/AEDT.
        const queryStartDate = subHours(startDate, hoursToAdd)
        const queryEndDate = subHours(endDate, hoursToAdd)

        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `events`), where('educationCenter', '==', id), where('start', '>=', queryStartDate.toISOString()), where('end', '<=', queryEndDate.toISOString()))))


        setEvents(await Promise.all((docs.map(async r => ({
            ...r, start: await offsetTime(r, 'start'),
            // end: await offsetTime(r, 'end'), event_id: r.id,
            // title: `${format(await getDaylightOffsetTime(r, 'start'), 'hh:mm a')}: ${r.title}`,
            // color: r.color
        })))))
    }

    const returnDay = (idx, index) => {
        let value = (idx * 7) + 1 + index - initialDayStart
        if (value < 1) {
            return ''
        } else if (value > parseInt(format(endDate, 'dd'))) {
            return ''
        }
        return value
    }


    const transformActivityName = (activityName, activity) => {
        const classType = getClassType(activity, '')

        if (classType === 'Yoga') {
            return 'Yoga'
        }
        if (classType === 'Sensory Fusion') {
            return sensoryActivityImageMap[activityName] || 'SensoryFusion'
        }
        if (classType === 'Gymnastics') {
            return gymnasticsActivityImageMap[activityName] || 'Gymnastics'
        }

        if (activityName === 'AFL') {
            return 'NFL'
        } else if (activityName === 'Genres') {
            return 'Tambourine'
        } else if (activityName === 'Scales') {
            return 'Xylophone'
        }
        return activityName
    }


    const getActivityImage = day => {
        const matchingEvent = events.find(r => parseInt(format(r.start, 'dd')) === day)
        // if ([1, 12, 23].includes(day)) {
        //     return require(`../assets/Activities/Football.png`)
        // }

        if (matchingEvent && matchingEvent.weekActivity) {
            const activityName = matchingEvent.weekActivity.split(':')[1]?.trim() || ''
            // console.log(`../assets/Activities/${transformActivityName(activityName, matchingEvent.activity)}.png`)
            if (activityName && activityWithImages.includes(transformActivityName(activityName, matchingEvent.activity))) {
                return require(`../assets/Activities/${transformActivityName(activityName, matchingEvent.activity)}.png`)
            } else {
                return require(`../assets/Activities/Gymnastics.png`)
            }
        } else if (matchingEvent && getClassType(matchingEvent.activity, matchingEvent.weekActivity) === 'Yoga') {
            return require(`../assets/Activities/Yoga.png`)
        } else if (matchingEvent && getClassType(matchingEvent.activity, matchingEvent.weekActivity) === 'Sensory Fusion') {
            return require(`../assets/Activities/SensoryFusion.png`)
        } else if (matchingEvent && getClassType(matchingEvent.activity, matchingEvent.weekActivity) === 'Gymnastics') {
            return require(`../assets/Activities/Gymnastics.png`)
        }
        return ''
    }

    return <div className="container" style={{ margin: 0, padding: 0 }}>
        {headerImage && <img src={headerImage} style={{ width: '100%', height: '300px', objectFit: 'cover' }} />}
        <table style={{ marginTop: '10px' }}>
            <thead>
                <tr>
                    {['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].map((day, idx) => <th key={day + idx} style={{ color: '#6ca2ff', textAlign: 'center' }}>
                        {day}
                    </th>)}
                </tr>
            </thead>
            <tbody>
                {[1, 2, 3, 4, 5].map((week, idx) => <tr key={week}>
                    {days.map((date, index) => <td key={date} style={{ height: '80px', width: '80px', verticalAlign: 'bottom' }}>
                        {getActivityImage(returnDay(idx, index)) ? <img src={getActivityImage(returnDay(idx, index))} style={{ display: 'flex', width: '80px', height: '80px', margin: 'auto' }} />
                            : <div style={{ width: '80px', height: '80px', margin: 'auto' }} />
                        }
                        <p style={{ margin: 0, textAlign: 'center' }}>{returnDay(idx, index)}</p>
                    </td>)}
                </tr>)}
            </tbody>
        </table>
    </div >
}

export default CalendarPdf
